import { createSlice } from "@reduxjs/toolkit";
import { fetchAboutUs } from "../actions/aboutUsAction";
import { REHYDRATE } from "redux-persist";

const initialState = {
  data: {
    id: 0,
    title: "",
    sub_title: "",
    content: "",
    video: "",
    image_file: "",
    image_path: "",
    image_file_02: "",
    image_path_02: "",
    created_user_id: 0,
    created_user_name: "",
    created_date: "",
    updated_user_id: 0,
    updated_user_name: "",
    updated_date: "",
  },
  isLoading: false,
  error: false,
};

export const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState,
  reducers: {
    aboutUs: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAboutUs.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAboutUs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchAboutUs.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(REHYDRATE, (state) => {
      const { data } = state;
      state.isLoading = false;
      state.data = data;
    });
  },
});

export const { aboutUs } = aboutUsSlice.actions;

export default aboutUsSlice.reducer;
